module.exports = __webpack_public_path__ + "assets/img/jianxia_score-2aa6b0cf.png";